// Format price in INR
export const formatPrice = (price) => {
  if (price === undefined || price === null || isNaN(price)) return '₹0';
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(price);
};

// Format date
export const formatDate = (date) => {
  return new Date(date).toLocaleDateString('en-IN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

// Format date with time
export const formatDateTime = (date) => {
  return new Date(date).toLocaleDateString('en-IN', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

// Calculate discount percentage
export const calculateDiscountPercent = (original, discounted) => {
  if (!original || !discounted || original <= discounted) return 0;
  return Math.round(((original - discounted) / original) * 100);
};

// Calculate discounted price
export const calculateDiscountedPrice = (price, discount) => {
  if (!price || !discount || !discount.isActive || !discount.value) return price;
  
  const now = new Date();
  if (discount.startDate && now < new Date(discount.startDate)) return price;
  if (discount.endDate && now > new Date(discount.endDate)) return price;
  
  if (discount.type === 'percentage') {
    return Math.max(0, Math.round(price * (1 - discount.value / 100)));
  } else {
    return Math.max(0, price - discount.value);
  }
};

// Truncate text
export const truncateText = (text, maxLength = 100) => {
  if (!text || text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

// Get order status color
export const getOrderStatusColor = (status) => {
  const colors = {
    pending: 'warning',
    confirmed: 'info',
    processing: 'info',
    shipped: 'info',
    out_for_delivery: 'info',
    delivered: 'success',
    cancelled: 'error',
    returned: 'error',
  };
  return colors[status] || 'info';
};

// Get payment status color
export const getPaymentStatusColor = (status) => {
  const colors = {
    pending: 'warning',
    paid: 'success',
    failed: 'error',
    refunded: 'info',
  };
  return colors[status] || 'info';
};

// Validate email
export const isValidEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
};

// Validate phone
export const isValidPhone = (phone) => {
  const re = /^[6-9]\d{9}$/;
  return re.test(phone);
};

// Validate pincode
export const isValidPincode = (pincode) => {
  const re = /^[1-9][0-9]{5}$/;
  return re.test(pincode);
};

// Debounce function
export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};
